import { render, staticRenderFns } from "./OrderDetailHotelView.vue?vue&type=template&id=633c9e64&scoped=true"
import script from "./OrderDetailHotelView.vue?vue&type=script&lang=js"
export * from "./OrderDetailHotelView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailHotelView.vue?vue&type=style&index=0&id=633c9e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c9e64",
  null
  
)

export default component.exports